import { createSelector } from "reselect";
import { getClassroomId } from "./classroomSelectors";
import orderByPosition from "./helpers/orderByPosition";

const getLevelGroups = (state) => state.entities.levelGroups;
export const getLevelGroup = (_, props) => props.levelGroup;

export const getLevelGroupsByClassroom = createSelector(
  getClassroomId,
  getLevelGroups,
  (classroomId, levelGroups) => {
    if (!levelGroups) return;
    return Object.values(levelGroups)
      .filter((levelGroup) =>
        levelGroup.classroomIds.includes(Number(classroomId))
      )
      .sort(orderByPosition);
  }
);
